import { PAYMENT_METHODS, type PaymentMethodKey } from '@c214/shared';
import { Button } from '../ui/button';
import { Chip } from '../ui/chip';
import { Textarea } from '../ui/textarea';

interface Props {
  paymentKey: PaymentMethodKey;
  onPaymentKeyChange: (key: PaymentMethodKey) => void;
  comment: string;
  onCommentChange: (value: string) => void;
  onBack: () => void;
  onSubmit: () => void;
  isSubmitting: boolean;
  submitError: string | null;
}

export function PaymentStep(props: Props) {
  return (
    <div>
      <p className="mono-label mb-6 text-accent">02 ОПЛАТА</p>
      <div className="flex flex-wrap gap-2">
        {PAYMENT_METHODS.map((method) => (
          <Chip
            key={method.key}
            active={props.paymentKey === method.key}
            onClick={() => props.onPaymentKeyChange(method.key)}
          >
            {method.label}
            {method.description && (
              <span className="ml-1 font-normal opacity-70">({method.description})</span>
            )}
          </Chip>
        ))}
      </div>

      <Textarea
        className="mt-4"
        placeholder="Коментар до замовлення (необовʼязково)"
        rows={3}
        value={props.comment}
        onChange={(e) => props.onCommentChange(e.target.value)}
      />

      {props.submitError && <p className="mt-3 text-[13px] text-warn">{props.submitError}</p>}

      <div className="mt-6 flex gap-3">
        <Button variant="secondary" size="lg" onClick={props.onBack} disabled={props.isSubmitting}>
          НАЗАД
        </Button>
        <Button
          variant="accent"
          size="lg"
          className="flex-1"
          onClick={props.onSubmit}
          disabled={props.isSubmitting}
        >
          ПІДТВЕРДИТИ ЗАМОВЛЕННЯ
        </Button>
      </div>
    </div>
  );
}
